import type { FC } from "react"

import { useRecoilValue } from "recoil"

import {
  divisionIntersectionsState,
  divisionPlaybackState,
} from "./division-visualization-state"
import { RainbowEdgeGroups } from "../Visuals/RainbowEdgeGroupsPlayback"

export const DivisionVisualization: FC = () => {
  const intersectionGroups = useRecoilValue(divisionIntersectionsState)
  const playbackPosition = useRecoilValue(divisionPlaybackState)
  console.log({ intersectionGroups, playbackPosition })

  return (
    <>
      <RainbowEdgeGroups
        edgeGroups={intersectionGroups.map((intersections) =>
          intersections.map((intersection) => intersection.edgeA[1]),
        )}
        playbackPosition={playbackPosition}
        offsetColor={-1}
      />
      <RainbowEdgeGroups
        edgeGroups={intersectionGroups.map((intersections) =>
          intersections.map((intersection) => intersection.edgeB[1]),
        )}
        playbackPosition={playbackPosition}
        offsetColor={2}
      />
    </>
  )
}
